import Vue from 'vue'
import Router from 'vue-router'

//框架
import layoutHeader from '@/components/layout'
Vue.use(Router);
//itemKind : 0、无，1、课程
const routes = [{
   path: '/',

   redirect: {
      name: 'index'
   },
   component: layoutHeader,
   children: [{
         path: '/login',
         name: 'sd_login_page',
         component: () => import('@/pages/login'),
         meta: {
            title: 'ISFAL',
            cache: false,
            autoStat: true
         }
      },
      {
         path: '/register',
         name: 'sd_register_page',
         component: () => import('@/pages/register'),
         meta: {
            title: 'ISFAL',
            cache: false,
            autoStat: true
         }
      },
      {
         path: '/password',
         name: 'sd_password_page',
         component: () => import('@/pages/password'),
         meta: {
            title: 'ISFAL',
            cache: false,
            autoStat: true
         }
      },

      {
         path: '/index',
         name: 'index',
         meta: {
            cache: true,
            title: 'ISFAL',
            autoStat: true
         },
         component: () => import('@/pages/index/index')
      },
      // About ISFAL
      {
         path: '/About_ISFAL',
         name: 'About_ISFAL',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/About_ISFAL')
      },
      // FoundersAndExperts
      {
         path: '/FoundersAndExperts',
         name: 'FoundersAndExperts',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/FoundersAndExperts.vue')
      },
      // FoundersAndExperts
      {
         path: '/Partners',
         name: 'Partners',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Partners.vue')
      },
      // Contact_Us
      {
         path: '/Contact_Us',
         name: 'Contact_Us',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Contact_Us.vue')
      },
      // Certification_System
      {
         path: '/Certification_System',
         name: 'Certification_System',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Certification_System.vue')
      },
      // Certification_Officers
      {
         path: '/Certification_Officers',
         name: 'Certification_Officers',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Certification_Officers.vue')
      },
      // Certificate_Search
      {
         path: '/Certificate_Search',
         name: 'Certificate_Search',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Certificate_Search.vue')
      },
      // Basic_Theory
      {
         path: '/Basic_Theory',
         name: 'Basic_Theory',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Basic_Theory.vue')
      },
      // Methodological Tools
      {
         path: '/Methodological_Tools',
         name: 'Methodological_Tools',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Methodological_Tools.vue')
      },
      // Key Skills
      {
         path: '/Key_Skills',
         name: 'Key_Skills',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Key_Skills.vue')
      },


      // Leadership Development
      {
         path: '/Leadership_Development',
         name: 'Leadership_Development',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Leadership_Development.vue')
      },
      // Organizational Development
      {
         path: '/Organizational_Development',
         name: 'Organizational_Development',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Organizational_Development.vue')
      },
      // Social Development
      {
         path: '/Social_Development',
         name: 'Social_Development',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Social_Development.vue')
      },
      // Professional Research
      {
         path: '/Professional_Research',
         name: 'Professional_Research',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Professional_Research.vue')
      },
      // Ravens Speech
      {
         path: '/Ravens_Speech',
         name: 'Ravens_Speech',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Ravens_Speech.vue')
      },
      // Expert Sharing
      {
         path: '/Expert_Sharing',
         name: 'Expert_Sharing',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Expert_Sharing.vue')
      },
      // Professional Publications
      {
         path: '/Professional_Publications',
         name: 'Professional_Publications',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/Professional_Publications.vue')
      },
      // 文章享清福
      {
         path: '/details/:code',
         name: 'details',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/details.vue')
      },
      // 搜索
      {
         path: '/search/:keywork',
         name: 'search',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/ISFAL/search.vue')
      },
      // 会议列表页
      {
         path: '/Conference/index',
         name: 'Conference_index',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/Conference/index.vue')
      },
      // 会议详情页
      {
         path: '/Conference/details/:code',
         name: 'Conference_details',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/Conference/details.vue')
      },
      // 视频详情页
      {
         path: '/Conference/video/:code',
         name: 'Conference_video',
         meta: {
            title: 'ISFAL',
         },
         component: () => import('@/pages/Conference/video.vue')
      },
   ]
}, ]

const router = new Router({
   routes: [
      ...routes,
   ],
   mode: 'hash',
   scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
         return savedPosition
      } else {
         return {
            x: 0,
            y: 0
         }
      }
   }
})

export default router